import { AppUtil } from 'kuaidong-lib'
import { IExemptionForm, IStudentLeaveForm } from 'kuaidong-model'
import { IStudentLeaveRecordItem } from 'kuaidong-model/src/approvalLeave'

interface IStudentLeaveParams {
  class_ids: string[]
  leave_type: string
  date?: string
  start_time?: string
  end_time?: string
  reason?: string
}

export class AApprovalLeave {
  static studentLeaveList(
    processed: boolean,
    params?: IStudentLeaveParams & {
      limit: number
      offset: number
    }
  ): Promise<{
    items: IStudentLeaveRecordItem[]
    count: number
  }> {
    return AppUtil.httpGET('/student_leaves', {
      processed,
      ...params,
    })
  }

  static addStudentLeave(form: IExemptionForm) {
    return AppUtil.httpPOST('/student_leaves', form)
  }

  static approveLeave(id: string) {
    return AppUtil.httpPOST('/student_leaves/approve', {
      id,
    })
  }

  static multiApproveLeave(ids: string[]) {
    return AppUtil.httpPOST('/student_leaves/approve', {
      ids,
    })
  }

  static rejectLeave(id: string, reason: string) {
    return AppUtil.httpPOST('/student_leaves/reject', {
      id,
      reason,
    })
  }

  static multiRejectLeave(ids: string[], reason?: string) {
    return AppUtil.httpPOST('/student_leaves/reject', {
      ids,
      reason,
    })
  }

  static async getLeaveSetting(): Promise<string[]> {
    const result = await AppUtil.httpGET('/student_leave/setting')
    return result['approve_types']
  }

  // 更新请假设置
  static async updateleaveSetting(approve_types: string[]): Promise<void> {
    return AppUtil.httpPOST('/student_leave/setting', { approve_types })
  }

  // 批量通过所有待处理请假
  static async postApproveAllStudentLeaves(params: IStudentLeaveParams) {
    return AppUtil.httpPOST('/student_leaves/approve_all', params)
  }

  // 批量拒绝所有待处理请假
  static async postRejectAllStudentLeaves(params: IStudentLeaveParams) {
    return AppUtil.httpPOST('/student_leaves/reject_all', params)
  }
}

export class AAskForLeave {
  static studentLeaveList(): Promise<IStudentLeaveRecordItem[]> {
    return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/student/student_leaves`)
  }

  static studentLeaveDetail(id: string): Promise<IStudentLeaveRecordItem> {
    return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/student/student_leave`, {
      id,
    })
  }

  // 创建请假
  static addStudentLeave(form: IStudentLeaveForm) {
    return AppUtil.httpPOST(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/student/student_leave`, form)
  }

  // 撤回请假
  static deleteStudentLeave(id: string) {
    return AppUtil.httpDelete(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/student/student_leave`, {
      id,
    })
  }
}
